import NavbarMenuToggle from "common/ui/NavbarMenuToggle";
import DocsSiteLink from "docs/common/DocsSiteLink";
import React, { PureComponent } from "react";
import { Dropdown } from "react-bootstrap";
import "./Help.scss";
import { localizeCommon as localize } from "features/localization/localizeService";
import SiteLink from "common/ui/SiteLink";
import { AppConstants } from "common/ui/appConstants";

interface HelpProps {
    merchantName: string;
    isCustomer: boolean;
    supportEmail: string;
    supportPhone: string;
    supportWebsiteUrl: string;
}

const Help: React.FC<HelpProps> = props => {

    const email = props.isCustomer && props.supportEmail?.length > 0 ? props.supportEmail : AppConstants.SupportEmail;
    const phone = props.isCustomer && props.supportPhone?.length > 0 ? props.supportPhone : AppConstants.SupportPhone;
    const websiteUrl = props.isCustomer && props.supportWebsiteUrl?.length > 0 ? props.supportWebsiteUrl : null;

    return <Dropdown className="help-center">
        <Dropdown.Toggle as={NavbarMenuToggle} id="help-toggle">
            <i className="material-icons" data-testid="help-icon">help</i>
        </Dropdown.Toggle>
        <Dropdown.Menu className="help-menu" data-testid="help-menu">
            <Dropdown.Header>
                <h4 data-testid="help-heading">{localize("Help_Header_Help")}</h4>
            </Dropdown.Header>
            <Dropdown.Divider />
            {props.isCustomer ? null : (
                <Dropdown.Item as={SiteLink.SupportTicket}  className="font-weight-bold" data-testid="help-submit-support-ticket-item">
                    <i className="material-icons">assignment</i>
                    {localize("Help_Button_Ticket")}
                </Dropdown.Item>
            )}
            <Dropdown.Item data-testid="help-phone-section">
                <i className="material-icons" data-testid="phone-icon">phone</i>
                <Phone number={phone} />
            </Dropdown.Item>

            <EmailItem address={email} subject="StoneX Hedge help" />

            {props.isCustomer && websiteUrl &&
                <LinkDropdownItem url={websiteUrl} openInNewTab>
                    <i className="material-icons">web</i> {props.merchantName} Homepage
                </LinkDropdownItem>
            }
            <Dropdown.Item as={DocsSiteLink.Home}>
                <i className="material-icons" data-testid="documentation-icon">menu_book</i> {localize("Help_Button_Documentation")}
            </Dropdown.Item>

            <Dropdown.Divider />
            <Dropdown.Item as={SiteLink.Troubleshooting}>
                <i className="material-icons">troubleshoot</i>
                {localize("Help_Button_Troubleshooting")}
            </Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>;
}

class Phone extends PureComponent<{ number: string }> {
    render() {
        return <a href={`tel:${this.props.number}`} data-testid="phone-number">{this.props.number}</a>;
    }
}

class EmailItem extends PureComponent<{ address: string, subject: string }> {
    render() {
        return <LinkDropdownItem url={`mailto:${this.props.address}?subject=${this.props.subject}`} data-testid="help-email"><i className="material-icons" data-testid="help-email-icon">email</i>
            {this.props.address}
        </LinkDropdownItem>;
    }
}

interface LinkDropdownItemProps {
    url: string;
    openInNewTab?: boolean;
    'data-testid'?: string;
}
class LinkDropdownItem extends PureComponent<LinkDropdownItemProps> {

    render() {
        return <a href={this.props.url} className="dropdown-item" target={this.props.openInNewTab ? "_blank" : ""} data-testid={this.props["data-testid"]}>{this.props.children}</a>
    }
}

export default Help;